export default __webpack_public_path__ + "img/dFaxqoIE.2f03ea36.svg";